// 品牌与产品
<template>
  <div class="main">
    <div class="head">
      <myheadert></myheadert>
      <!-- <img src="~@/assets/brand_img/stockvault.jpg"> -->
      <img src="~@/assets/aboutMe_img/u6086-4.png" class="title" />
    </div>
    <div class="middle">
      <div class="location">
        <img src="~@/assets/common_img/house.png" />
        <span class="place">您的位置：<span @click="goHome">主页</span>＞品牌与产品</span>
      </div>
    </div>
    <div class="showBrand">
      <div class="showBrandTop">
        <div class="showCategory">
          <span class="categoryTitle">品牌名称：</span>
          <span class="categoryTitleAll" @click="selecAllProduct">全部</span>
          <span class="categoryTitle">HUZER</span>
        </div>
        <div class="showCategory">
          <span class="categoryTitle">产品类别：</span>
          <span class="categoryTitleAll" @click="selecAllProduct">全部</span>
          <ul v-for="(category,index) in categoryList" :key="index" id="productCategory">
            <li @click="selectProductByCategory(category.categoryId)">{{category.categoryName}}</li>
          </ul>
        </div>
        <div class="showCategory">
          <span class="categoryTitle">合作平台：</span><img src="~@/assets/brand_img/taobao.png" class="taobao" @click="taobao()"><img src="~@/assets/brand_img/crlogo.png" class="crlogo">
        </div>
      </div>
      <div class="showBrandBottom">
        <ul>
          <li v-for="(item, index) in productList" :key="index" @click="product(item.productId)">
            <!-- <div class="productImg"><img src="~@/assets/brand_img/HZGB03-02.png"></div> -->
            <div class="productImg"><img :src='require("../../assets/brand_img/" + item.productsrc)'></div>
            <div class="productName"><p>{{item.productName}}</p><p>{{item.productModel}}</p></div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default{
  name: 'brand',
  data () {
    return {
      categoryList: [],
      productList: []
    }
  },
  created () {
    this.selectCategory()
    this.selecAllProduct()
  },
  methods: {
    goHome () {
      this.$router.push(
        {
          path: '/'
        }
      )
      location.reload()
    },
    selectCategory () {
      var that = this
      this.$axios.post('http://' + this.global.url + ':8081/api/user/selectCategory')
        .then(function (res) {
          console.log(res.data)
          that.categoryList = res.data
          console.log(this.categoryList)
        })
        .catch(function (res) {
          console.log(res.data)
        })
    },
    selecAllProduct () {
      var that = this
      this.$axios.post('http://' + this.global.url + ':8081/api/user/selectAllProduct')
        .then(function (res) {
          console.log(res.data)
          that.productList = res.data
          console.log(this.productList)
        })
        .catch(function (res) {
          console.log(res.data)
        })
    },
    selectProductByCategory (id) {
      var that = this
      console.log(id)
      this.$axios.post('http://' + this.global.url + ':8081/api/user/selectProductByCategory', this.$qs.stringify({
        categoryId: id
      }))
        .then(function (res) {
          // console.log('----------')
          // that.productList = []
          // console.log(this.productList)
          console.log(res.data)
          that.productList = res.data
          // console.log(this.productList + 'list')
        })
        .catch(function (res) {
          console.log(res.data)
        })
    },
    taobao () {
      window.open('https://shop442891054.taobao.com/?spm=a230r.7195193.1997079397.2.2a245b01cReiLN', '_blank')
    },
    product (id, src) {
      console.log(id, src)
      this.$router.push(
        {
          path: '/showBrand',
          query: {
            productId: id
          }
        }
      )
    }
  }
}
</script>
<style scoped>
.showBrandTop{
  width: 100%;
  height: auto;
  background-color: #f5f5f5;
  /* margin-left: 15%; */
  margin-top: -20px;
}
.showBrandTop span{
  margin-left: 30px;
}
.showCategory{
  margin-top: 40px;
}
.showCategory:first-child{
  padding-top: 20px;
}
.showCategory:last-child{
  padding-bottom: 20px;
}
.categoryTitle{
  font-size: 18px;
  color: #666;
  cursor: pointer;
}
.categoryTitleAll{
  font-size: 18px;
  color: red;
  cursor: pointer;
}
#productCategory{
  width: 12%;
  list-style: none;
  display: inline-block;
  cursor: pointer;
  /* padding: 0;
  margin: 0; */
}
#productCategory li{
  font-size: 18px;
  text-align: center;
  color: #666;
}
.taobao,.crlogo{
  margin-left: 10%;
  cursor: pointer;
}
.crlogo{
  width: 10%;
}
.taobao{
  width: 3%;
}
.showBrandBottom{
  width: 100%;
  height: auto;
  /* margin-left: 15%; */
  padding-top: 20px;
}
.showBrandBottom ul{
  list-style: none;
}
.showBrandBottom ul li{
  width: 15%;
  height: 250px;
  /* border: 1px solid black; */
  margin-left: 4%;
  /* display:inline-block; */
  float: left;
  text-align: center;
  padding-bottom: 100px;
  /* margin-top: 50px; */
}
.productImg{
  width: 100%;
  height: auto;
  /* line-height: 250px; */
  box-shadow: 0 0 5px rgb(90, 90, 90);
  cursor: pointer;
}
.productImg img{
  width: 100%;
  height: auto;
  vertical-align: middle;
}
.productName{
  width: 100%;
  height: 50px;
  padding-top: 10px;
  cursor: pointer;
}
@media screen and (min-width: 1500px){
  /* 顶部 */
.head{
  width: 100%;
  height: 253px;
  background-image: url('~@/assets/brand_img/stockvault.jpg');
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.title{
  width: 900px;
  margin-top: 25px;
}
/* 位置 */
.location{
  width: auto;
  height: 27px;
  /* border: 1px red solid; */
  margin-top: 1%;
  margin-left: 14.5%;
  font-size: 18px;
  font-family: "宋体";
  /* color: black; */
}
.location img{
  display: inline-block;
}
.place{
  position: relative;
  left: 0.2%;
  top: -5px;
  cursor: pointer;
}
/* 产品 */
.showBrand{
  width: 1200px;
  height: auto;
  margin: 0 auto;
}
.productImg{
  width: 100%;
  height: 250px;
  line-height: 250px;
  box-shadow: 0 0 5px rgb(90, 90, 90);
  cursor: pointer;
}
}
@media screen and (min-width: 1200px) and (max-width:1499px){
  /* 顶部 */
.head{
  width: 100%;
  height: 253px;
  background-image: url('~@/assets/brand_img/stockvault.jpg');
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.title{
  width: 750px;
  margin-top: 20px;
}
/* 位置 */
.location{
  width: auto;
  height: 27px;
  /* border: 1px red solid; */
  margin-top: -3%;
  margin-left: 14.5%;
  font-size: 18px;
  font-family: "宋体";
  /* color: black; */
}
.location img{
  display: inline-block;
}
.place{
  position: relative;
  left: 0.2%;
  top: -5px;
  cursor: pointer;
}
/* 产品 */
.showBrand{
  width: 1000px;
  height: auto;
  margin: 0 auto;
}
.productImg{
  width: 100%;
  height: 200px;
  line-height: 200px;
  box-shadow: 0 0 5px rgb(90, 90, 90);
  cursor: pointer;
}
.showBrandBottom ul li{
  width: 15%;
  height: 220px;
  padding-bottom: 50px;
}
#productCategory{
  width: 15%;
}
}
@media screen and (min-width: 960px) and (max-width:1199px){
  /* 顶部 */
.head{
  width: 100%;
  height: 253px;
  background-image: url('~@/assets/brand_img/stockvault.jpg');
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.title{
  width: 600px;
  /* margin-left: 20px; */
  margin-top: 10px;
}
/* 位置 */
.location{
  width: auto;
  height: 20px;
  /* border: 1px red solid; */
  margin-top: -6%;
  margin-left: 14.5%;
  font-size: 16px;
  font-family: "宋体";
  /* color: black; */
}
.location img{
  width: 3%;
  display: inline-block;
}
.place{
  position: relative;
  left: 0.2%;
  top: -5px;
  cursor: pointer;
}
/* 产品 */
.showBrand{
  width: 800px;
  height: auto;
  margin: 0 auto;
}
.productImg{
  width: 100%;
  height: 160px;
  line-height: 160px;
  box-shadow: 0 0 5px rgb(90, 90, 90);
  cursor: pointer;
}
.showBrandBottom ul li{
  width: 15%;
  height: 200px;
  padding-bottom: 50px;
}
#productCategory{
  width: 15%;
}
#productCategory li{
  font-size: 16px;
}
}
@media screen and (min-width: 768px) and (max-width:959px){
  /* 顶部 */
.head{
  width: 100%;
  height: 253px;
  background-image: url('~@/assets/brand_img/stockvault.jpg');
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.title{
  width: 400px;
  /* margin-left: 30px; */
  /* margin-top: 10px; */
}
/* 位置 */
.location{
  width: auto;
  height: 20px;
  /* border: 1px red solid; */
  margin-top: -11%;
  margin-left: 14.5%;
  font-size: 12px;
  font-family: "宋体";
  /* color: black; */
}
.location img{
  width: 3%;
  display: inline-block;
}
.place{
  position: relative;
  left: 0.2%;
  top: -5px;
  cursor: pointer;
}
/* 产品 */
.showBrand{
  width: 600px;
  height: auto;
  margin: 0 auto;
}
.productImg{
  width: 100%;
  height: 130px;
  line-height: 130px;
  box-shadow: 0 0 5px rgb(90, 90, 90);
  cursor: pointer;
}
.showBrandBottom ul li{
  width: 15%;
  height: 180px;
  padding-bottom: 50px;
}
#productCategory{
  width: 15%;
}
#productCategory li{
  font-size: 12px;
}
}
@media screen and (min-width: 702px) and (max-width:767px){
  /* 顶部 */
.head{
  width: 100%;
  height: 253px;
  background-image: url('~@/assets/brand_img/stockvault.jpg');
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.title{
  width: 500px;
  margin-left: 50px;
}
/* 位置 */
.location{
  width: auto;
  height: 27px;
  /* border: 1px red solid; */
  margin-top: -12%;
  margin-left: 14.5%;
  font-size: 12px;
  font-family: "宋体";
  /* color: black; */
}
.location img{
  width: 3%;
  display: inline-block;
}
.place{
  position: relative;
  left: 0.2%;
  top: -5px;
  cursor: pointer;
}
/* 产品 */
.showBrand{
  width: 600px;
  height: auto;
  margin: 0 auto;
}
.productImg{
  width: 100%;
  height: 130px;
  line-height: 130px;
  box-shadow: 0 0 5px rgb(90, 90, 90);
  cursor: pointer;
}
.showBrandBottom ul li{
  width: 15%;
  height: 180px;
  padding-bottom: 50px;
}
#productCategory{
  width: 15%;
}
#productCategory li{
  font-size: 12px;
}
}
@media screen and (max-width:701px){
  .main{
    width: 100%;
    height: auto;
  }
/* 顶部 */
.head{
  width: 100%;
  height: auto;
  background-image: url('~@/assets/brand_img/stockvault.jpg');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.title{
  width: 50%;
  margin-left: 30%;
  margin-top: 10px;
}
/* 位置 */
.location{
  width: auto;
  height: 20px;
  margin-top: 10px;
  margin-left: 10%;
  font-size: 12px;
  font-family: "宋体";
  /* color: black; */
}
.location img{
  width: 6%;
  display: inline-block;
}
.place{
  position: relative;
  left: 1.2%;
  top: -5px;
  cursor: pointer;
}
/* 产品 */
.showBrand{
  width: 80%;
  height: auto;
  margin: 0 auto;
}
.showBrandTop{
  margin-top: 0;
}
.productImg{
  width: 100%;
  height: 100px;
  line-height: 100px;
  box-shadow: 0 0 5px rgb(90, 90, 90);
  cursor: pointer;
}
#productCategory{
  width: 30%;
}
#productCategory li{
  font-size: 12px;
}
.taobao,.crlogo{
  margin-left: 5%;
  cursor: pointer;
}
.taobao{
  width: 5%;
}
.crlogo{
  width: 15%;
}
.showBrandBottom ul li{
  width: 15%;
  height: 170px;
  padding-bottom: 20px;
}
.categoryTitle{
  font-size: 14px;
}
.showBrandTop span{
  margin-left: 1%;
}
.categoryTitleAll{
  font-size: 12px;
}
.showCategory{
  margin-top: 20px;
}
.productName p{
  font-size: 12px;
}
}
</style>



// WEBPACK FOOTER //
// src/components/brand/brand.vue